import { createRouter, createWebHashHistory } from 'vue-router'
import layout from '@/layout'
import store from '@/store'

import Accounts from './modules/account/index'
import Operations from './modules/operation/index'
import Originals from './modules/original/index'
import Goods from './modules/goods'
import Config from './modules/config/index'
import GoodsNew from './modules/goods_new'
import Supply from './modules/supply'
import MediciIndex from './modules/medicine/index'
import SalaryIndex from './modules/salary/index'
import inIndex from './modules/in/index'
import Tools from './modules/tools/index'
import Display from './modules/display'
import permission from './modules/permission/index'
import Other from './modules/other'

/**
 * 私有路由表 需要有权限才能访问
 */
export const privateRoutes = [
  Accounts, // 备用金（现金）
  Operations, // 店铺运营记录
  Supply, // 供应链（集团管理）
  Originals, // 原料（中央厨房）
  GoodsNew, // 研发中心
  MediciIndex, // 药品@药品管理
  SalaryIndex, // 人力
  inIndex, // 进货管理
  Goods, // 扣库（菜品）
  Tools, // 工具
  Config, // 配置
  Display, // 展示
  permission, // 权限
  Other // 其他
]
/**
 * 公开路由表 不需要登录 就能访问的页面
 */
export const publicRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index')
  },
  {
    path: '/bindWx',
    component: () => import('@/views/login/bindwx')
  },
  {
    path: '/',
    // 注意：带有路径“/”的记录中的组件“默认”是一个不返回 Promise 的函数
    component: layout,
    redirect: '/index',
    children: [
      // 首页
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: {
          title: '首页',
          icon: 'home'
        }
      },
      // 404 页面
      {
        path: '/404',
        name: '404',
        component: () => import('@/views/error_page/404')
      },
      // 401 页面
      {
        path: '/401',
        name: '401',
        component: () => import('@/views/error_page/401')
      }
    ]
  }
]

export function resetRouter () {
  if (
    store.getters.adminInfo &&
    store.getters.adminInfo.permission &&
    store.getters.adminInfo.permission.menus
  ) {
    const menus = store.getters.adminInfo.permission.menus

    menus.forEach((menu) => {
      router.removeRoute(menu)
    })
  }
}

const router = createRouter({
  history: createWebHashHistory(),
  routes: publicRoutes
})

export default router
